import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

export async function uploadFile(file, category) {
  const form = new FormData();
  form.append("file", file);
  const res = await api.post(`/upload${category ? `?category=${encodeURIComponent(category)}` : ""}`, form, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  return res.data;
}

export const fileUrl = (path) => `${API}/files/${path}`;
